// Лёгкие маски ввода по тегу вопроса (matr module v8). Без сторонних библиотек: форматируем
// «на лету» в onChange (см. SkFieldText). Валидацию формата дублирует yup-схема
// (ValidationSchemaFromQuestions). Маски НЕ мутируют ничего, кроме строки значения.

export type InputMask = (raw: string) => string;

/** Паспорт РФ, серия и номер — только цифры, формат «XXXX XXXXXX». */
export const formatRussianPassportNumber: InputMask = (raw) => {
  const digits = `${raw}`.replace(/\D/g, "").slice(0, 10);
  return digits.length <= 4 ? digits : `${digits.slice(0, 4)} ${digits.slice(4)}`;
};

/** Код подразделения паспорта РФ — только цифры, формат «XXX-XXX». */
export const formatPassportSubdivisionCode: InputMask = (raw) => {
  const digits = `${raw}`.replace(/\D/g, "").slice(0, 6);
  return digits.length <= 3 ? digits : `${digits.slice(0, 3)}-${digits.slice(3)}`;
};

/**
 * Теги вопросов, хранящих одно имя (ФИО). Маска ``capitalizeName`` принудительно
 * делает первую букву заглавной «на лету», чтобы пользователь не мог оставить имя
 * со строчной первой буквой. Состав зеркалит бэкенд-``NAME_TAGS``
 * (regs/services/name_normalizer.py): составные однострочные поля ``fio-ru`` /
 * ``fio-ru-non-rf`` сюда не входят (правило одного символа испортило бы второй токен).
 */
export const NAME_TAGS: ReadonlySet<string> = new Set([
  "name",
  "surname",
  "full_name",
  "full_name-non-rf",
  "full_last",
  "full_last-non-rf",
  "first-name-ru",
  "first-name-ru-non-rf",
  "last-name-ru",
  "last-name-ru-non-rf",
  "patronymic-ru",
  "patronymic",
  "short_name",
  "short_last",
]);

/**
 * Делает первую букву заглавной, остальную часть строки не трогает. В отличие от
 * ``String.prototype.capitalize``/``toLowerCase`` хвоста, сохраняет ``O'Brien`` /
 * ``McDonald`` / ``MARY``. Пробелы не обрезаются (это делает бэкенд при сохранении),
 * чтобы не мешать вводу составных имён вроде «Mary Jane».
 */
export const capitalizeName: InputMask = (raw) => {
  const s = `${raw}`;
  return s.length === 0 ? s : s[0].toUpperCase() + s.slice(1);
};

/** Маска ввода для вопроса по его тегу (v8); undefined — поле без маски. */
export const inputMaskForTag = (tag: string): InputMask | undefined => {
  if (tag === "russian-passport-number") return formatRussianPassportNumber;
  if (tag === "russian-passport-subdivision-code") return formatPassportSubdivisionCode;
  if (NAME_TAGS.has(tag)) return capitalizeName;
  return undefined;
};
